{
  "averageDailyUsage": {
    "title": "Utilizzo medio giornaliero",
    "unitLabel": "Acri-pollici/giorno"
  },
  "downloadWaterUsageReportButton": "Scarica il rapporto",
  "estimatesWarning": {
    "message": "I dati qui visualizzati derivano da stime storiche e non devono essere utilizzati nella tenuta dei registri ufficiali.",
    "title": "Visualizzazione delle stime storiche"
  },
  "farmWideWaterUsage": {
    "title": "Utilizzo dell'acqua in tutta l'azienda agricola",
    "unitLabel": "Acro-piedi"
  },
  "flowSourceToggle": {
    "label": "Fonte dei dati:"
  },
  "flowSummaryTable": {
    "headings": {
      "peakFlowRate": "Portata di picco (GPM)",
      "totalVolumeAcreFeet": "Volume totale (piedi cubi)"
    },
    "title": "Riepilogo dell'utilizzo dell'acqua in azienda agricola"
  },
  "flowTimeseries": {
    "axisLabels": {
      "y": "Volume (acri-piedi)"
    },
    "title": "Utilizzo nel tempo"
  },
  "highestFlowRate": {
    "pumpWithDeviceName": "Pompa: {{deviceName}}",
    "title": "Portata massima",
    "unitLabel": "Galloni/Minuto"
  },
  "noDataFound": "Nessun dato trovato per i filtri specificati",
  "peakDailyUsage": {
    "onWithDate": "Il {{date, datetime}}",
    "title": "Utilizzo giornaliero massimo",
    "unitLabel": "Acri-pollici"
  },
  "pumpFlowStackedTimeseries": {
    "axisLabels": {
      "y": "Volume (acri piedi)"
    },
    "title": "Volume totale nel tempo"
  },
  "pumpTotalHorizontalBar": {
    "axisLabels": {
      "x": "Volume (acri-piedi)"
    },
    "title": "Volume totale per pompa"
  },
  "title": "Analisi del flusso"
}
